import type { ReactNode } from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface NewsletterCheckboxProps {
  isChecked: boolean
  onCheckedChange: (checked: boolean) => void
  isDisabled?: boolean
  className?: string
}

/**
 * Labeled checkbox for newsletter opt-in.
 * Designed for use in auth flows (e.g. sign-up).
 */
export const NewsletterCheckbox: React.FC<NewsletterCheckboxProps> = ({
  isChecked,
  onCheckedChange,
  isDisabled = false,
  className,
}): ReactNode => (
  <div className={cn('newsletter-checkbox flex items-start gap-2.5', className)}>
    <Checkbox
      id="newsletter"
      checked={isChecked}
      onCheckedChange={(checked) => onCheckedChange(checked === true)}
      disabled={isDisabled}
      className="mt-0.5"
    />
    <Label
      htmlFor="newsletter"
      className="cursor-pointer text-sm leading-snug font-normal text-muted-foreground"
    >
      Send me useful tips &amp; updates (no spam)
    </Label>
  </div>
)
